module.exports = __webpack_public_path__ + "static/img/p-10.0d95020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-10.png
// module id = kjXs
// module chunks = 0